import { render } from "./RenewGoodsLog.vue?vue&type=template&id=80726b18&scoped=true"
import script from "./RenewGoodsLog.vue?vue&type=script&lang=js"
export * from "./RenewGoodsLog.vue?vue&type=script&lang=js"

import "./RenewGoodsLog.vue?vue&type=style&index=0&id=80726b18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80726b18"]])

export default __exports__